import React, { useState, useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Switch,
} from "react-router-dom";
import "./App.css";
import "./assets/fonts/feather/feather.woff";
import { AppContext } from "./context";

import LoginPage from "./views/Login";
import LogOutPage from "./views/Logout";
import CreatePage from "./views/create-request";
import LogRequestPage from "./views/log-request";
import EditRequestPage from "./views/edit-request";
import ViewRequest from "./views/view-request";
import AddValidation from "./views/add-validations"
import ApprovalPage from "./views/approvals";
import Dashboard from "./views/dashboard";
import UsersPage from "./views/users";
import MapPage from "./views/users/mapUsers";
import ProtectedRoute from "./auth";
// import Routes from "./routes";

function App() {
  //pass global authentication variable from api here
  const appdata = useContext(AppContext);

  const [isAuth, setIsAuth] = appdata[0];

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/logout" element={<LogOutPage />} />
        <Route
          element={
            <ProtectedRoute isAuth={isAuth}>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route path="create" element={<CreatePage />} />
          <Route path="log-request" element={<LogRequestPage />} />
          <Route path="edit-request" element={<EditRequestPage />} />
          <Route path="view-request" element={<ViewRequest />} />
          <Route path="add-validation" element={<AddValidation />} />
          <Route path="approvals" element={<ApprovalPage />} />
          <Route path="create-users" element={<UsersPage />} />
          <Route path="map-users" element={<MapPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
